import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const inflationValue = (state, props) => (
  whatIfInnerSelector(state, props).Inflation
);

export default inflationValue;
